// GRADIFY brand marks. The wordmark renders the dot of the "i" as a filled
// Chalkboard-green bubble — the logotype contains the product's core action.
export const TAGLINE = 'Grading, Recording And Data-driven Item-analysis For You';

/** Inline wordmark: Gradify with a bubble i-dot. Uses the display font via CSS. */
export function wordmark(): string {
  return `<span class="wordmark" aria-label="Gradify">Grad<span class="i-dot">ı</span>fy</span>`;
}

/** Brand hero block for the top of a primary tab (wordmark + tagline). */
export function brandHero(): string {
  return `<div class="brand-hero">${wordmark()}<span class="tagline">${TAGLINE}</span></div>`;
}
